/*
 * healthmart
 * version 2.2
 * http://www.healthmart.com
 *
 * Copyright (c) 2019 healthmart ltd
 * Author healthmart ltd <support@healthmart.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input, Output, forwardRef, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-input-control',
    templateUrl: './input-control.component.html',
    styleUrls: ['./input-control.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputControlComponent),
            multi: true
        }],
    standalone: false
})

export class InputControlComponent implements OnInit, ControlValueAccessor {

    @Input() inputType: any;
    @Input() currentValue: any;
    @Input() inputPlaceHolder: string;
    @Input() inputId: string;
    @Input() inputName: string;
    @Input() inputWrapperClass: string;
    @Input() labelText: string;
    @Input() lableClass: string = 'label fs-5 text-1 fw-500';
    @Input() inputClass: string = 'form-control fs-6 my-3 p-3 border-0 bg-7 br-05';
    @Input() icon: string;
    @Input() iconClass: string;
    @Input() iconWrapperClass: string = 'input-group-text border-0 bg-7 br-05 my-t-b-3';
    @Input() error: any;
    @Input() errorMessage: any;
    @Input() errorMessage_required: any;
    @Input() errorMessage_pattern: any;
    @Input() checked: boolean;
    @Input() additionInputClass: string;
    @Input() fcontrol: any;

    dateName: any;
    @ViewChild('input') inputRef: ElementRef;  
   

    @Output() emptyDecorator: EventEmitter<any> = new EventEmitter();
    @Output() TextChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() keyup: EventEmitter<any> = new EventEmitter<any>();

    touched = false;
    checkbox:boolean = true;
    checkboxChecked = false;
    passwordFieldType = 'password';
    passwordEyeIcon = 'fas fa-eye';

    constructor() { }

    ngOnInit(): void {
        this.dateName = this.inputName;
        if (this.checked) {
            this.checkboxChecked = true
        }
        this.inputClass = this.inputClass + ' ' + this.additionInputClass;   
        
    }

    onTouched: any = () => { };
    ngOnChanges() { }

    //The internal data model for form control value access
    private innerValue: any = '';

    // event fired when input value is changed . later propagated up to the form control using the custom value accessor interface
    onChange(e: any, value: any) {
        this.touched = true;
        //set changed value
        this.innerValue = value;
        // propagate value into form control using control value accessor interface
        this.propagateChange(this.innerValue);
        this.keyup.emit(true);
    }

    // Handle paste events with a small delay to ensure value is captured on mobile
    onPaste(e: any) {
        setTimeout(() => {
            const value = e.target.value;
            this.touched = true;
            this.innerValue = value;
            this.propagateChange(this.innerValue);
            this.keyup.emit(true);
        }, 0);
    }

    onChangecheckbox(e: any, value: any){
        //set changed value
        this.innerValue = e.target.checked;
        // propagate value into form control using control value accessor interface
        this.propagateChange(this.innerValue);
        this.keyup.emit(true);
    }

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
        }
    }

    //propagate changes into the custom form control
    propagateChange = (_: any) => { }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        this.innerValue = value;
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    passwordShowHide() {
        if (this.passwordFieldType == 'text') {
            this.passwordFieldType = 'password';
            this.passwordEyeIcon = 'fas fa-eye';
        } else {
            this.passwordFieldType = 'text';
            this.passwordEyeIcon = 'fas fa-eye-slash';
        }
    }
}